import * as React from 'react';
export var PopoverContext = React.createContext({
    excludeClickOutsideClasses: [],
});
//# sourceMappingURL=PopoverContext.js.map